var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      staticClass: "entry-layout",
      staticStyle: { height: "100vh", "min-width": "1200px" },
    },
    [
      _vm.isAuthStore
        ? _c(
            "entry-layout-header",
            {
              class: {
                "disable-click": _vm.$refs["ErpEmptyModalRef"]?.disableClick,
              },
              attrs: {
                favorites: _vm.favorites,
                menus: _vm.menus,
                subMenus: _vm.subMenus,
                customTabs: _vm.customTabs,
                customMenus: _vm.customMenus,
                activeKey: _vm.activeKey,
                currentLang: _vm.currentLang,
                panesHistory: _vm.panesHistory,
              },
              on: {
                menusadd: _vm.handleAddCustomMenus,
                menuschange: _vm.handleMenusChange,
                menuchange: _vm.handleMenuChange,
                custommenu: _vm.handleEditCustomMenus,
                viewall: _vm.handleViewAll,
              },
            },
            [
              _vm._t("rightContentRender", null, {
                slot: "rightContentRender",
              }),
            ],
            2
          )
        : _c("entry-guide-header"),
      _c(
        "section",
        { staticClass: "entry-layout" },
        [
          _c("entry-multi-tab", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isAuthStore,
                expression: "isAuthStore",
              },
            ],
            ref: "multiTab",
            class: {
              "disable-click": _vm.$refs["ErpEmptyModalRef"]?.disableClick,
            },
            attrs: {
              favorites: _vm.favorites,
              menus: _vm.menus,
              panes: _vm.panes,
              activeKey: _vm.activeKey,
              currentLang: _vm.currentLang,
            },
            on: { change: _vm.handleMenuChange },
          }),
          _c("ticker", { staticClass: "entry-ticker-bar" }),
          _c(
            "entry-layout-content",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isAuthStore,
                  expression: "isAuthStore",
                },
              ],
            },
            [_vm._t("default")],
            2
          ),
          !_vm.isAuthStore ? _c("entry-guide-content") : _vm._e(),
          _c("erpModal"),
          _vm.isAuthStore
            ? _c("erp-empty-modal", { ref: "ErpEmptyModalRef" })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }